import { IServiceReview } from "../../components/PublicModal";
import { IPagination } from "../../data/AppInterface";
import { TReactSetState, TSetPaginationFn } from "../../data/AppType";
import { IServiceForSubCategory } from "../../screens/product-services/Web/ProductServiceDetailsWebController";
import { GET_ALL_SERVICE_CATEGORY_FOR_TREND } from "../../services/Endpoints";
import {
  GET_PUBLIC_SERVICE_BY_ID,
  GET_PUBLIC_SERVICE_RATING_BY_ID,
  GET_SERVICE_PUBLIC,
} from "../../services/public-product-services/public-product/PublicService";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import { toastError } from "../../utils/AppFunctions";
import { generatePaginationFromApiRes } from "../../utils/AppFunctions";
export const fetchPublicServiceApi = async (
  setServicesList: TReactSetState<IServiceForSubCategory[]>,
  setLoading: TReactSetState<boolean>,
  pagination: IPagination,
  setPagination: TSetPaginationFn,
  servicesList: IServiceForSubCategory[],
  trendingFlag: boolean
) => {
  try {
    setLoading(true);
    const publicServiceList = await GET_SERVICE_PUBLIC(
      pagination,
      trendingFlag
    );
    if (
      publicServiceList &&
      publicServiceList.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      if (publicServiceList && publicServiceList.data.item.length > 0) {
        setServicesList(publicServiceList.data.item);
        setPagination({
          ...pagination,
          ...generatePaginationFromApiRes(publicServiceList.data.pagination),
        });
        // All the comments needed in future
        // setServicesList([...servicesList, ...publicServiceList.data.item]);
      }
      //  else setServicesList(publicServiceList.data.item);
      // setPagination({
      //   ...pagination,
      //   ...generatePaginationFromApiRes(publicServiceList.data.pagination),
      // });
    } else {
      toastError(publicServiceList.message);
    }
  } catch (error: any) {
    toastError(
      error?.publicServiceList.message || MESSAGE_UNKNOWN_ERROR_OCCURRED
    );
  } finally {
    setLoading(false);
  }
};

export const fetchPublicServiceByIdApi = async (
  setGetServiceForSubCategory: TReactSetState<IServiceForSubCategory | null>,
  setLoading: TReactSetState<boolean>,
  id: number
) => {
  try {
    setLoading(true);
    const service = await GET_PUBLIC_SERVICE_BY_ID(id);

    if (service && service.code === DEFAULT_STATUS_CODE_SUCCESS) {
      setGetServiceForSubCategory(service.data);
    } else {
      toastError(service.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    }
  } catch (error: any) {
    toastError(error?.service?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
  } finally {
    setLoading(false);
  }
};
export const fetchPublicServiceRatingsByIdApi = async (
  setRatings: TReactSetState<IServiceReview[]>,
  setLoading: TReactSetState<boolean>,
  id: number
) => {
  try {
    setLoading(true);
    const service = await GET_PUBLIC_SERVICE_RATING_BY_ID(id);

    if (service && service.code === DEFAULT_STATUS_CODE_SUCCESS) {
      setRatings(service.data);
    } else {
      toastError(service.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    }
  } catch (error: any) {
    toastError(error?.service?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
  } finally {
    setLoading(false);
  }
};
